/* @flow */

import { tablet } from '@braindate/ui/lib/token/mediaQuery';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  notificationsMenu: {
    width: '100%',
    maxWidth: 408,

    [tablet]: {
      width: '100vw',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: [15, 17, 6, 17],
  },
  title: {
    margin: 0,
  },
  actionButton: {
    padding: [0, 16],
    height: 32,
  },
  button: {
    cursor: 'pointer',
    display: 'flex',
    borderRadius: ({
      withRoundedChild,
    }: ThemeFunction<{ withRoundedChild: boolean }>) =>
      withRoundedChild ? '50%' : 'unset',
  },
  feed: {
    paddingBottom: 16,
    maxHeight: 490,
    overflowY: 'auto',
  },
};
